import React, { useState, useEffect } from 'react';

interface TickerProps {
  messages?: string[];
}

const Ticker: React.FC<TickerProps> = ({ messages }) => {
  const defaultMessages = [
    "🎉 New player achieved a perfect score on VIP tier! 🏆",
    "💰 Weekly leaderboard prizes now available - compete to win!",
    "🔥 Premium tier questions updated with new historical events",
    "⚡ Lightning round mode coming soon - stay tuned!",
    "🏅 Top 10 players this week earn exclusive NFT rewards",
    "🎯 Daily challenge: Answer 5 questions in under 60 seconds",
    "🌟 VIP members get early access to new game modes",
    "📈 Player accuracy rates have increased 25% this month!",
    "🎮 Mobile app beta testing begins next week",
    "💎 Special weekend bonus multipliers now active!"
  ];

  const tickerMessages = messages || defaultMessages;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === tickerMessages.length - 1 ? 0 : prevIndex + 1
        );
        setIsVisible(true);
      }, 500);
    }, 4000);

    return () => clearInterval(interval);
  }, [tickerMessages.length]);

  return (
    <div className="ticker-container">
      <div className="ticker-content">
        <div className="ticker-label">
          <span className="ticker-icon" aria-hidden="true"></span>
          <span>LIVE</span>
        </div>
        <div className="ticker-message-container">
          <div className={`ticker-message ${isVisible ? 'visible' : 'hidden'}`}>
            {tickerMessages[currentIndex]}
          </div>
        </div>
        <div className="ticker-dots">
          {tickerMessages.map((_, index) => (
            <span 
              key={index} 
              className={`ticker-dot ${index === currentIndex ? 'active' : ''}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ticker;